import { inject, Injectable } from "@angular/core";
import { DialogService } from "@app/widgets/base/dialog/dialog.service";

@Injectable({
	providedIn: "root",
})
export class SimilarPricesLauncherService {
	private readonly dialogService = inject(DialogService);

	public openStandalone(): void {
		import(
			"@app/modules/planning_office/pickups/dialogs/similar-prices-dialog/similar-prices-dialog.component"
		).then(({ SimilarPricesDialogComponent: Dialog }) => {
			this.dialogService.open(Dialog, {
				data: {
					standalone: true,
					companyId: null,
					totalLinearMeters: null,
					totalWeight: null,
					totalPallets: null,
					loadDate: null,
					unloadDate: null,
					pickupId: null,
				},
				height: "100%",
				position: "right",
			});
		});
	}
}
